import { render, staticRenderFns } from "./default.vue?vue&type=template&id=462aeddd&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RuntimeEnvironmentWarning: require('/builds/2oYM8JSf/1/pmi/claim-management-tool/frontend/components/RuntimeEnvironmentWarning.vue').default})
